x<template lang="pug">
#feed
  .feed-wrapper(infinite-wrapper)
    post(v-for="(item, index) in items" :key="item.id" :item="item")
    .clearfix
  infinite-loading(:identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots" force-use-infinite-wrapper :distance="200" no-results="Nothing found...")
</template>

<script>
import { mapGetters } from "vuex";

import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

// Components
import Post from "@/components/Post";

export default {
  name: "Feed",
  components: {
    InfiniteLoading,
    Post
  },
  data() {
    return {
      items: [],
      page: -1,
      infiniteId: 1
    };
  },
  computed: {
    ...mapGetters(["category"])
  },
  watch: {
    category() {
      this.items = [];
      this.page = 0;
      this.infiniteId = new Date();
    }
  },
  methods: {
    infiniteHandler($state) {
      this.page += 1;
      axios
        .get(`${process.env.VUE_APP_API_URL}/photos/feed`, {
          params: {
            page: this.page,
            category: this.category,
            count: 20
          }
        })
        .then(response => {
          if (response.data.photos.length) {
            this.items.push(...response.data.photos);

            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        });
    }
  }
};
</script>

<style lang="stylus">
#feed {
  .feed-wrapper {
    max-width: $feed-width;
  }

  +tablet() {
    padding-top: 20px;
  }

  #posts {
    overflow-y: auto;
  }
}
</style>
